<template>
  <el-container class="app_container">
    <el-header class="app_header" style="height: 60px">
      <!--Header-->
      <main-header>
        <!-- Top Nav -->
        <nav-menu-item :navs="navs" :activeIndex="activeIndex">
          <div class="app_logo" slot="head">
            <img class="logo_pic" src="../assets/img/JLL-Logo.png" />
            <!-- <span class="logo_title size-16 white" slot="foot">
              {{ $t("common_pageText.WEBAPPNAME") }}
            </span> -->
             <span class="app_welcome black" slot="foot" style="float:right;">{{
              pageText.welcomMsg
            }}</span>
          </div>
         
          <div class="app_user black" slot="foot">
            
            <span><span style="font-size:14px">SAMEX Systems eTendering Support Hotline</span>(<a class="app_logout" href="http://www.samexsys.com" target="_blank" style="text-decoration:underline">www.samexsys.com</a>)
            <br v-if="windowWidth<1280">:<span style="font-size:14px">+852 8111 4290</span>&nbsp;| <a class="app_logout" href="mailto:support@samexsys.com" style="text-decoration:underline">support@samexsys.com</a>
              <a class="app_logout" href="https://youtu.be/P6fehD0mjWM" target="_blank" style="text-decoration:underline"><b>Click Here for User Manual</b></a>
            </span>
            <div class="profile_photo ">
              <img class="" src="../assets/img/noprofile.png" />
             
            </div> 
            <span class="app_logout">{{ pageText.loginUser }}{{ hrid }}</span>
            |
            <a class="app_logout" @click="changepwd" v-show="this.issupplier=='true'">{{ pageText.changepwd }}</a>
            |
            <a class="app_logout" @click="logout">{{ pageText.logout }}</a>
            <div class="app_lang" v-if="false">
              <button
                type="button"
                class="lang_btn size-14"
                :class="language == 'EN' ? 'active' : ''"
                :disabled="language == 'EN'"
                @click="changeLang('EN')"
              >
                Eng</button
              >|
              <button
                type="button"
                class="lang_btn size-14"
                :class="language == 'ZH' ? 'active' : ''"
                :disabled="language == 'ZH'"
                @click="changeLang('ZH')"
              >
                简</button
              >|
              <button
                type="button"
                class="lang_btn size-14"
                :class="language == 'ZHT' ? 'active' : ''"
                :disabled="language == 'ZHT'"
                @click="changeLang('ZHT')"
              >
                繁
              </button>
            </div>
          </div>
        </nav-menu-item>
      </main-header>
      <!-- <top-header>
        <div class="header">
              <el-row :gutter="20">
               <el-col :span="1"><div class="">&nbsp;</div></el-col>
                <el-col :span="14"><div class="profile_photo ">
                    <img class="" src="../assets/img/noprofile.png" />
                    <span class="app_logout1">{{ pageText.loginUser }}{{ hrid }}</span>
                    </div></el-col>
                <el-col :span="1"><div class="">&nbsp;</div></el-col>
                <el-col :span="8"><div class="  ">
                    <div class="rightheader" slot="foot">
                    <a class="app_logout1" @click="gotomycompro">{{ pageText.MyComPro }}</a>
                    <span style="padding-top:12px;font-size:20px">|</span>
                    <a class="app_logout1" @click="changepwd">{{ pageText.changepwd }}</a>
                    <span style="padding-top:12px;font-size:20px">|</span>
                    <a class="app_logout1" @click="logout">{{ pageText.logout }}</a></div>
                </div></el-col>
              </el-row>   
          </div>
      </top-header> -->
    </el-header>
    <el-container class="app_main_container">
      <el-aside class="app_aside" style="width: 250px;" v-if="false">
        <!--Left Menu-->
        <tree-menu-item
          :menus="menus"
          :activeIndex="activeIndex"
          :openedIndex="openedIndex"
        >
          <div></div>
        </tree-menu-item>
      </el-aside>
      <el-main class="app_main">
        <!--Main Content-->
        <keep-alive>
          <!-- <router-view
            ref="view-child"
            v-if="this.$route.meta.keepAlive && isRouterAlive"
          ></router-view> -->
        </keep-alive>
        <router-view
          ref="view-child"
         
        ></router-view>
      </el-main>
    </el-container>
    <el-footer class="app_footer" style="height:20px">
      <!--Footer-->
      <main-footer></main-footer>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import MainHeader from "../components/layout/Header.vue";
//import TopHeader from "../components/layout/TopHeader.vue";
import NavMenuItem from "../components/menu/NavMenuItem.vue";
import TreeMenuItem from "../components/menu/TreeMenuItem.vue";
import MainFooter from "../components/layout/Footer.vue";
import { token, postRequest } from "../utils/api";
import { Promise } from "q";

export default {
  components: {
    MainHeader,
    //TopHeader,
    NavMenuItem,
    TreeMenuItem,
    MainFooter
  },
  provide() {
    return {
      reload: this.reload,
      getHeader: this.getUserDetail
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isCollapse: false,
      issupplier: "",
      windowWidth:document.documentElement.clientWidth,
      user: {
        loginid: "",
        logintype: "0",
        token: ""
      },
      pageText: {
        welcomMsg: this.$t("common_pageText.WELCOMEMSG"),
        loginUser: this.$t("common_pageText.LOGINUSER"),
        logout: this.$t("common_pageText.LOGOUT"),
        changepwd: "Change Password",
        MyComPro: "My Company Profile",
      }
    };
  },
  computed: {
    ...mapGetters("menu", ["activeIndex", "openedIndex", "navs", "menus"]),
    ...mapGetters("user", [
      "description",
      "fileUserImgBase64",
      "hrid",
      "language"
    ])
  },
  mounted() {
    this.init();
    var that = this;
        // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
              window.fullWidth = document.documentElement.clientWidth;
              that.windowWidth = window.fullWidth; // 宽
            })()
          };
  },
  methods: {
    init() {
      this.issupplier = this.$cookies.get("issupplier");
      this.getUserDetail();
      
    },
    getUserDetail() {},
    reload() {
      let _this = this;
      _this.isRouterAlive = false;
      _this.$nextTick(() => (_this.isRouterAlive = true));
    },
    changeLang(lang) {
      let _this = this;
      _this.$store.commit("user/setLanguage", lang);
      _this.$i18n.locale = lang;
      // _this.reload();
    },
    gotomycompro(){
      this.$router.replace("/mycompanyprofile");
    },
    changepwd(){
      //this.$router.go(0);
      this.$router.replace("/changepassword");
      //
    },
    logout() {
      let _this = this;
      _this.user.loginid = _this.hrid;
      _this.user.token = token;
      _this
        .logoutHandle(_this.user)
        .then(res => {
          if (res.success) {
            _this.$router.go(0);
            _this.$store.commit("user/removeUser");
            _this.$router.replace("/login?langcode=" + _this.$i18n.locale);
            
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch(error => {
          _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
        });
    },
    logoutHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("userLogout", {
          loginid: user.loginid,
          logintype: user.logintype,
          token: token,
          maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.pageText.welcomMsg = this.$t("common_pageText.WELCOMEMSG");
      this.pageText.loginUser = this.$t("common_pageText.LOGINUSER");
      this.pageText.logout = this.$t("common_pageText.LOGOUT");
    },
    windowWidth(val){
        let that = this;
        console.log("实时屏幕宽度：",val, that.windowHeight );
    },
  }
};
</script>
<style scoped>
.app_header {
  height: 60px;
  /* position: fixed; */
  top: 0;
  width: 100%;
}
.app_container {
  height: 100%;
  position: relative;
}
.app_logo {
  /* display: flex; */
  /* display: -ms-flexbox; */
  margin-top: 13px;
  /* width: 250px; */
  /* border-right: 1px solid #f0f0f0; */
  /* text-align: center; */
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.logo_pic {
  height: 30px;
}
.logo_title {
  /* width: 100%; */
  font-weight: 800;
  line-height: 60px;
  text-align: center;
  flex: 1;
}
.app_welcome {
  margin-left: 10px;
  line-height: 40px;
  text-align: center;
  flex: 1;
}
.app_main_container {
  /* position: absolute;
  top: 60px; */
  width: 100%;
  bottom: 20px;
  box-sizing: border-box;
}
.app_main {
  height: 100%;
  overflow: auto;
  background-color: #f0f0f0;
}
.app_aside {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #222;
}
.app_user {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.profile_photo {
  display: flex;
  align-self: center;
  /* margin: auto 5px; */
}
.profile_photo > img {
  width: 54px;
  height: 54px;
  /* margin-left: 10px;
  margin-right: 10px; */
  border-radius: 50%;
  border: 3px solid #fff;
  box-sizing: border-box;
  background-color: #fff;
}
.app_currentName {
  display: block;
  /* color: #fff; */
  /* font-weight: 700; */
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.app_logout {
  font-size:12px;
  padding: 5px;
}
.app_logout1 {
  font-size:24px;
  padding: 10px;
}
.app_logout:link,.app_logout1:link{
  color:#000000;
}
.app_logout:hover,.app_logout1:hover,
.app_logout:active,.app_logout1:active {
  color: #a50606;
}
.app_lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto 80px auto 20px;
}
.lang_btn,
.lang_btn:hover,
.lang_btn:focus,
.lang_btn:active {
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
}
.lang_btn:hover,
.lang_btn.active {
  color: #a50606;
  font-weight: 700;
}
.app_footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: 0;
}
.header{
    background: #fff;
    height: 80px;
    padding-top: 20px;
}
</style>